import gql from "graphql-tag.macro";

import { getClient } from "Globals/api";
import { ONE_SECOND } from "Globals/constants/constants";

const query = gql`
 query Tasks {
    Tasks {
      user
      id
      title
      body
      timestamp
      read
      link
      tag
    }
  }
`;

const loadSingleTaskQuery = gql`
 query LoadSingleTask ($payload: TaskQueryInput!) {
  LoadSingleTask (task: $payload) {
      user
      id
      title
      body
      timestamp
      read
      link
      tag
    }
  }
`;

const mutationQuery = gql`
mutation UpdateManyTasksRead ($payload: [TaskUpdateReadInput!]!, $context: TaskQueryInput!){
  updateManyTasksRead (tasks: $payload, context: $context){
    user
    id
    title
    body
    timestamp
    read
    link
    tag
  }
}
`;

const subscriptionQuery = gql`
  subscription SubscribeTask ($payload: TaskQueryInput!) {
    tasksUpdated (task: $payload) {
      user
      id
      title
      body
      timestamp
      read
      link
      tag
    }
  }
`;

export const loadTasks = async () => {
    const client = await getClient("workflowtasks");
    const { data } = await client.query({ query });
    return data;
};

export const loadSingleTask = async task => {
    const client = await getClient("workflowtasks");
    const { data } = await client.query({ 
        query: loadSingleTaskQuery, 
        variables: { payload: task } 
    });
    return data;
};

export const updateManyTasks = async tasks => {
    const client = await getClient("workflowtasks");
    const data = await client.mutate({
        mutation: mutationQuery,
        // Add the user id here for now to work with mock api
        variables: { payload: tasks.map(n => ({ ...n, user: "1" })), context: { user: "1" } },
    });
    return data;
};

const mockSubscribeTasks = (subject, emit) => {
    setTimeout(async () => {
        emit(await loadTasks());
    }, ONE_SECOND);
    return () => null;
};

export const subscribeTasks = (window?.app?.config?.v3MockApiEnabled || process.env.STORYBOOK_IS_STORYBOOK)
    ? mockSubscribeTasks 
    : async (subject, emit) => {
        const subjectType = subject.startsWith("id-") ? "id" : "user";
        const subjectVal = subjectType === "id" ? subject.substring(3) : subject;
        const client = await getClient("workflowtasks");
        const observable = client.subscribe({
            query: subscriptionQuery,
            variables: { payload: { user: "1", [subjectType]: subjectVal } },
        });
        const subscription = observable.subscribe(val => emit(val));
        return () => subscription.unsubscribe();
    };
